/** Authored additions reuse existing behavior, with explicit overrides. */
export interface CreatureDefinition {
    template: string
    hp?: number
    speed?: number
    hostility?: number
    faction?: string
    scanDistanceTiles?: number
    drops?: { item: string; quantity: number; probability: number }[]
}

import { AUTHORED_CREATURES, AUTHORED_WEAPONS } from "../content/appearance"
/** Body classification inherits the original template, including through authored descendants. */
export const behaviorRaceFor = (race: string): string => {
    const visited = new Set<string>()
    while (AUTHORED_CREATURES[race] && !visited.has(race)) { visited.add(race); race = AUTHORED_CREATURES[race].template }
    return race
}

/** Weapon art, ammo and combat metadata reuse the original template profile. */
export const behaviorWeaponFor = (weapon: string): string => {
    const visited = new Set<string>()
    while (AUTHORED_WEAPONS[weapon] && !visited.has(weapon)) { visited.add(weapon); weapon = AUTHORED_WEAPONS[weapon] }
    return weapon
}
